import i18n from '@opsbase/lib-i18n';
import markdown from '@opsbase/react-markdown';
import Vertical from '@opsbase/web-layout/Vertical';
import Spinner from '@opsbase/web-ui/Spinner';
import Text from '@opsbase/web-ui/Text';
import React from 'react';
import ReactPlayer from 'react-player';
export function OnboardingWelcome(props) {
    const { loadingSystemSettings, systemDataSettings, name } = props;
    return (React.createElement(Spinner, { busy: loadingSystemSettings }, () => (React.createElement(Vertical, { gutter: true, paddingX: true },
        React.createElement(Text, { variant: 'h2' }, i18n.t('welcome-opsbase-line1', { name })),
        React.createElement(Text, null, i18n.t('welcome-opsbase-line2')),
        React.createElement(Text, null, markdown(i18n.t('welcome-opsbase-line3'))),
        React.createElement("div", { style: { height: 30, aspectRatio: '1' } },
            React.createElement(ReactPlayer, { controls: true, height: 300, width: 600, url: systemDataSettings.webIntroUrl }))))));
}
export default OnboardingWelcome;
